
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch/memes/[slug]",
      function () {
        return require("private-next-pages/watch/memes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watch/memes/[slug]"])
      });
    }
  